var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0304 3.91721C10.3498 4.00971 9.69654 4.06799 9.05633 4.19301C6.47589 4.69676 4.34398 5.98655 2.64497 7.99405C1.21795 9.6776 0.321526 11.7504 0.069912 13.9482C0.0195923 14.3497 0.0119724 14.7574 0.000543594 15.1628C-0.0098362 15.5356 0.159777 15.7768 0.457748 15.8541C0.716305 15.9211 0.97184 15.7905 1.14526 15.4841C2.03048 13.8941 3.32742 12.575 4.89827 11.667C6.44759 10.7639 8.20983 10.2964 10.0004 10.3136C10.3102 10.3143 10.6199 10.3151 10.9294 10.3159C10.9634 10.3202 10.9971 10.3264 11.0303 10.3347V10.6227C11.0303 11.6043 11.0345 12.5859 11.028 13.5675C11.026 13.8714 11.1208 14.1093 11.4066 14.2298C11.6851 14.3475 11.9111 14.236 12.116 14.0353C14.302 11.8976 16.4892 9.76121 18.6774 7.62601C19.0083 7.30251 19.0041 6.97477 18.6682 6.64678C16.4814 4.51034 14.2936 2.37474 12.105 0.239986C11.9029 0.0425528 11.6846 -0.075589 11.3988 0.0549757C11.124 0.180254 11.0277 0.402927 11.0287 0.693394C11.0323 1.67501 11.0301 2.65663 11.0301 3.63824L11.0304 3.91721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyIcon);
export default __webpack_public_path__ + "static/media/reply-icon.5b676367edd049adcac37e1baa0762c1.svg";
export { ForwardRef as ReactComponent };